import { CommonModule, DatePipe, Location, formatDate } from '@angular/common';
import { Component, LOCALE_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faCalendar, faChevronLeft, faPlus, faTicket } from '@fortawesome/pro-light-svg-icons';
import { faCalendarClock } from '@fortawesome/pro-light-svg-icons';
import { NgbDate, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AppSettings } from 'src/app/app-settings';
import { CartService } from 'src/app/services/cart.service';
import { EventsService } from 'src/app/services/events.service';


@Component({
  selector: 'app-event-tickets',
  templateUrl: './event-tickets.component.html',
  styleUrls: ['./event-tickets.component.scss'],
})
export class EventTicketsComponent {

  eventSelected!: any;
  eventId!: any;
  loaded = false;

  optionsHours: any[] = [];
  numDaySelect!: number;
  dateString: any;
  today = new Date();
  hourSelected!: any;

  enabledTickets: any[] = [];
  selectTickets: any[] = [];
  optionsTickets: any[] = [];
  selectedDate!: NgbDateStruct;
  fechasEvent!: any;
  dateDaySelect!: number;

  faChevronLeft = faChevronLeft;
  faCalendarClock = faCalendarClock;
  faCalendar = faCalendar;
  faTicket = faTicket;
  faPlus = faPlus;

  ticketClasses!: any;
  ticketClassesNames: string[] = [];

  constructor(private datePipe: DatePipe, private router: Router, private activatedRoute: ActivatedRoute, private eventsService: EventsService, private location: Location, public formatter: NgbDateParserFormatter, public cartService: CartService) {
    this.activatedRoute.params.subscribe(data => {
      this.eventId = data['idEvent'];
      if (this.eventId) {


        this.eventsService.getEventById(this.eventId).subscribe(response => {
          this.loaded = true;
          this.eventSelected = response;
          this.optionsHours = this.eventSelected.horarios.filter((hor: any) => hor.activo == true);
          this.optionsHours = this.optionsHours.sort((a: any, b: any) => {
            return new Date(a.horaInicio).getTime() - new Date(b.horaInicio).getTime();
          })

          if (this.optionsHours.length === 1) {
            this.hourSelected = this.optionsHours[0];
            localStorage.setItem('timeEvent', this.hourSelected.horaInicio)
          }
          this.fechasEvent = this.eventSelected.fechas.find((event: any) => event.activo == true);
        })
      }
    })
    if (localStorage.getItem('dateString')) {
      this.dateString = localStorage.getItem('dateString')
    }
    if (localStorage.getItem('selectedDateYear') && localStorage.getItem('selectedDateMonth') && localStorage.getItem('selectedDateDay')) {
      this.selectedDate = new NgbDate(Number(localStorage.getItem('selectedDateYear')), Number(localStorage.getItem('selectedDateMonth')), Number(localStorage.getItem('selectedDateDay')));
    }
    if (localStorage.getItem('numDaySelect')) {
      this.numDaySelect = Number(localStorage.getItem('numDaySelect'));
    }
    if (localStorage.getItem('dateDaySelect')) {
      this.dateDaySelect = Number(localStorage.getItem('dateDaySelect'));
    }

  }
  changeHour(hour: any) {
    this.hourSelected = hour;
    this.getTicketsEnabled();
    localStorage.setItem('timeEvent', this.hourSelected.horaInicio)
  }

  getTicketsEnabled() {
    this.enabledTickets = [];
    this.selectTickets = [];
  }


  addClassToElement(element: HTMLElement, className: string) {
    element.classList.add(className)
  }

  removeClassFromElement(element: HTMLElement, className: string) {
    element.classList.remove(className);
  }

  filterTicketClass(className: string) {
    return this.ticketClasses.filter((ticketclass: any) => ticketclass.name === className)
  }

  goBack() {
    this.location.back();
  }

  viewMap() {
    this.router.navigate(['event/seatmap/' + this.eventId]);
  }


  formatNumber(floatValue = 1, decimals = 3, multiplier = 1) {
    let floatMultiplied = floatValue * multiplier;
    let stringFloat = floatMultiplied + "";
    let arraySplitFloat = stringFloat.split(".");
    let decimalsValue = "0";
    if (arraySplitFloat.length > 1) {
      decimalsValue = arraySplitFloat[1].slice(0, decimals);
    }
    let integerValue = arraySplitFloat[0];
    let arrayFullStringValue = [integerValue, decimalsValue];
    let FullStringValue = arrayFullStringValue.join(".")
    let floatFullValue = parseFloat(FullStringValue) + "";
    let formatFloatFullValue = new Intl.NumberFormat('de-DE', { minimumFractionDigits: decimals, style: 'currency', currency: 'EUR' }).format(Number(floatFullValue));
    return formatFloatFullValue;
  }

}
